import React from "react";
import logo from "../assets/searchEdu.logo.png";

export const Experience = () => {
  return (
    <div
      style={{ backgroundColor: "#202235" }}
      name="Experience"
      className=" w-full max-h-fit			"
    >
      <div className="md: max-w-screen-lg mx-auto p-4 flex flex-col justify-center  h-full text-white sm: w-full">
        <div className="text-center">
          <p className="text-white	 text-4xl">Experience</p>
          <p className=" text-orange-600">—•— Work Experience —•—</p>
        </div>

        <div className="md:flex text-justify  gap-10 sm:block m-auto  ">
          <div className="p-10  text-white">
            <div className="flex items-center">
              <img
                src={logo}
                alt="Search-edu-Logo"
                className="w-10 h-10 rounded-full mr-5"
              />
              <h4 className=" md:text-3xl font-bold sm: text-2xl">Search Education</h4>
            </div>
            <p className="text-xl">(Full Stack Developer)</p>
            <br />
            <p>
              As a MERN Stack Developer, I had the opportunity to work with the
              cutting-edge technologies of the MERN stack(MongoDB, Express.js,
              React.js, Node.js).
            </p>
            <br/>
            <h3 className="text-xl  text-orange-600">Key Responsibilities :-</h3>
            <ul className="list-disc ml-8 text-md leading-loose">
              <li>
                Designed and implemented responsive user interfaces using
                React.js, ensuring an optimal user experience across different
                devices and screen sizes.
              </li>
              <li>
                Developed RESTful APIs using Express.js and Node.js, enabling
                seamless data exchange between the front-end and back-end.
              </li>
              <li>
                Implemented authentication and authorization mechanisms, such
                as JWT (JSON Web Tokens), to enhance the security of the
                applications.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
